import gql from 'graphql-tag';

const getAdditionalCreditDetailsQuery = gql`
  query GetAdditionalCreditDetailsQuery(
    $organisationId: String!,
    $types: [String]!
    $owners: [String]!
  ) {
    getAdditionalCreditDetails(
      organisationId: $organisationId,
      types: $types
      owners: $owners
    ) {
      ... on AdditionalCreditProductDetails {
        type
        product
        balance
        consumption
        thisMonthOnlyRecurringBalance
        thisMonthOnlyRecurringConsumption
        recurringConsumption
      }
      ... on AdditionalCreditTeamDetails {
        teamId
        teamName
        type
        balance
        consumption
        thisMonthOnlyRecurringBalance
        thisMonthOnlyRecurringConsumption
        recurringConsumption
      }
    }
  }
`;

export default (() => ({
  query: getAdditionalCreditDetailsQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: (data) => {
    const {
      organisationId,
      owners,
      types
    } = data;
    return {
      organisationId,
      owners,
      types
    };
  }
}));